import React, { FC } from 'react'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { ShowAllBlockCustom, ShowAllBlockCustomProps } from '@/shared/ui/ShowAllBlockCustom'

import cls from './ReadMoreHTML.module.scss'

const buttonTextProps: ShowAllBlockCustomProps['buttonText'] = {
	activeText: 'Свернуть',
	defaultText: 'Читать полностью'
}

interface ReadMoreHTMLProps extends Pick<ShowAllBlockCustomProps, 'contentShortHeight' | 'hasGradient'> {
	html: string
}

const ReadMoreHTML: FC<ReadMoreHTMLProps> = ({ html, contentShortHeight = 'sm', hasGradient = true, ...props }) => {
	return (
		<ShowAllBlockCustom
			contentShortHeight={contentShortHeight}
			hasGradient={hasGradient}
			buttonText={buttonTextProps}
			{...props}>
			<div className={cls.root} dangerouslySetInnerHTML={createMarkup(html)} />
		</ShowAllBlockCustom>
	)
}

export default ReadMoreHTML
